import React, { ComponentType, useState } from 'react';

import { LeftOutlined } from '@ant-design/icons';
import { Flex, Layout, Row } from 'antd';

import { SignOutButton } from 'components';
import { goBack, replace } from 'connected-react-router';
import { useDispatch } from 'react-redux';

import { ModalExitOnConfirmation } from 'components';

import { QuestionnaireGreyButton } from 'components/button/button-base';
import { useReduxAuthStore } from 'lib/hooks/auth/use-auth';
import './Header.scss';
import CRxSmall from 'img/crx-small.png';
import { useHistory } from 'react-router-dom';

const { Header } = Layout;

interface BaseHeaderProps {
  marginBottom?: number;
  headerStyle?: React.CSSProperties;
}

export function BaseHeader(props: BaseHeaderProps) {
  const user = useReduxAuthStore();
  const history = useHistory();

  // const user = useSelector((state: RootState) => state.auth.user);
  // const [showModal, toggleModal] = useState(false);
  return (
    <Header
      className={'crx-header'}
      style={{
        height: '60px',
        backgroundColor: 'white',
        ...props.headerStyle,
        marginBottom: props.marginBottom
      }}
    >
      <Flex>
        <img
          style={{ width: 40 }}
          src={CRxSmall}
          onClick={() => history.push('/')}
        />
        {user.user && <SignOutButton rounded={true} buttonType="text" />}
      </Flex>

      <Row justify="space-between" align="middle"></Row>
    </Header>
  );
}

export interface QuestionnaireHeaderProps {
  /**
   * The title of the header
   */
  title: string;
  /**
   * The label of the back button
   */
  headerButtonLabel?: string;
  /**
   * Set this to `true` if the header button should be hidden.
   * This is `false` by default.
   */
  hideHeaderButton?: boolean;

  /**
   * Override the action button in the header
   */
  headerButtonOverride?: ComponentType;
  // onBack: () => void;
  // on button click on back(?)
  // label for button?
}

export function QuestionnaireHeader(props: QuestionnaireHeaderProps) {
  const dispatch = useDispatch();

  const back = () => dispatch(goBack());
  const ButtonRender = props.headerButtonOverride ? (
    <props.headerButtonOverride />
  ) : (
    <QuestionnaireGreyButton icon={<LeftOutlined />} onClick={back}>
      {props.headerButtonLabel ?? 'Back'}
    </QuestionnaireGreyButton>
  );
  return (
    <Header
      className={'crx-header'}
      style={{ height: '40px', backgroundColor: 'white' }}
    >
      <Row align="middle">
        {!props.hideHeaderButton && ButtonRender}
        <span className="questionnaire-header__title">
          {props.title ?? 'Questionnaire'}
        </span>
      </Row>
    </Header>
  );
}

// export interface FaqProps {
//   min: number;
//   max: number;
//   instructions?: string;
//   description?: string;
// }

interface OutcomeMeasuresHeaderProps {
  title: string;
  label: string;
  onExit?: () => void;
  // onNext: () => void;
  backgroundColor?: string;
  // faq?: FaqProps;
}
export function OutcomeMeasuresHeader({
  backgroundColor = 'white',
  ...props
}: OutcomeMeasuresHeaderProps) {
  // const [showModal, toggleModal] = useState(false);
  const [showExitModal, toggleExitModal] = useState(false);
  const dispatch = useDispatch();
  function handleExitOnClose() {
    props.onExit?.();
    dispatch(replace('/'));
  }
  function handleExitOnCancel() {
    toggleExitModal(false);
  }

  return (
    <>
      <Header
        className="crx-header"
        style={{ height: '84px', backgroundColor: backgroundColor }}
      >
        <Row align="middle" justify="space-between">
          <Row align="middle">
            <QuestionnaireGreyButton
              // label={props.label}
              // rounded={true}
              icon={<LeftOutlined />}
              onClick={() => {
                toggleExitModal(!showExitModal);
              }}
            >
              {props.label}
            </QuestionnaireGreyButton>
            <span className="questionnaire-header__title">{props.title}</span>
          </Row>

          {/* <QuestionCircleFilled
            onClick={() => {
              toggleModal(!showModal);
            }}
            style={{ fontSize: '25px' }}
          />
          {/*<FaqModal showModal={showModal} onClose={() => {toggleModal(false)}}/>*/}
          {
            /* <ModalRatingInstructionAndFaqs
            showModal={showModal}
            onClose={() => toggleModal(false)}
          /> */
            <ModalExitOnConfirmation
              showModal={showExitModal}
              onClose={handleExitOnClose}
              onCancel={handleExitOnCancel}
            />
          }
        </Row>
      </Header>
    </>
  );
}

interface SaveAndExitHeaderProps {
  title: string;
  label: string;
  onExit: () => void;
  backgroundColor?: string;
}
export const SaveAndExitHeader = ({
  title,
  label = 'Save & exit',
  onExit,
  backgroundColor = 'white'
}: SaveAndExitHeaderProps) => {
  return (
    <Header
      className="crx-header"
      style={{ height: '84px', backgroundColor: backgroundColor }}
    >
      <Row align="middle">
        <QuestionnaireGreyButton
          // minWidth={125}
          // label={label}
          // rounded={true}
          icon={<LeftOutlined />}
          onClick={onExit}
        >
          {label}
        </QuestionnaireGreyButton>
        <span className="questionnaire-header__title">{title}</span>
      </Row>
    </Header>
  );
};
